__turbopack_context__.v({
  "banner": "_1_rl_G_banner",
});
